import axiosAuth from '@/axiosMain';

async function index() {
  let response = await axiosAuth.get('/energy_suppliers');
  return response.data.data;
}

async function store(data) {
  let response = await axiosAuth.post('/energy_suppliers', data);
  return response.data.data;
}

export default {
  index,
  store,
};
